/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NipsScore from './nips-score';
import NipsScoreDetail from './nips-score-detail';
import NipsScoreUpdate from './nips-score-update';
import NipsScoreDeleteDialog from './nips-score-delete-dialog';

const NipsScoreRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NipsScore />} />
    <Route path="new" element={<NipsScoreUpdate />} />
    <Route path=":id">
      <Route index element={<NipsScoreDetail />} />
      <Route path="edit" element={<NipsScoreUpdate />} />
      <Route path="delete" element={<NipsScoreDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NipsScoreRoutes;
